

declare let FilesFingerprint: any;

export default class Mathjax {
    public src: string;
    public config: string;
    elements = {
        head: document.head,
        mathJaxSrc: document.createElement('script')
    };
    constructor() {
        this.config = 'MathJax.Hub.Config({CommonHTML: { linebreaks: { automatic: true } },"HTML-CSS": { linebreaks: {automatic: true}},SVG: { linebreaks: { automatic: true} },});'
        this.init();
    }
    init() {
        try {
            (window as any).MathJax = JSON.parse(JSON.stringify(this.config));
            const nonce = UX && UX.getRequestId ? UX.getRequestId() : null;
            if(nonce) {
                this.elements.mathJaxSrc.nonce = nonce;
            }
            this.elements.mathJaxSrc.type = 'text/javascript';
            this.elements.mathJaxSrc.src = `${UX.utils.releasedAssetsPath()}public/mathjaxV2-${FilesFingerprint.mathjaxV2}/MathJax.js?config=TeX-MML-AM_CHTML`;
            this.elements.head.appendChild(this.elements.mathJaxSrc);
        } catch (error) {
            console.error("something went wrong when importing Mathjax :", error)
        }
    }
}